export interface AudioLabUiLogEntry {
  id: string;
  timestamp: string;
  message: string;
  context?: string;
}

interface AudioLabLogPanelProps {
  title: string;
  emptyLabel: string;
  entries: AudioLabUiLogEntry[];
  tone?: "normal" | "error";
}

export function AudioLabLogPanel({ title, emptyLabel, entries, tone = "normal" }: AudioLabLogPanelProps) {
  return (
    <section className={`audio-lab-log-panel is-${tone}`} aria-label={title}>
      <div className="audio-lab-log-heading">
        <h2>{title}</h2>
        <span>{entries.length}</span>
      </div>
      {entries.length === 0 ? (
        <p className="audio-lab-empty-log">{emptyLabel}</p>
      ) : (
        <ol>
          {entries.map((entry) => (
            <li key={entry.id}>
              <time>{entry.timestamp}</time>
              <span>{entry.message}</span>
              {entry.context ? <code>{entry.context}</code> : null}
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
